/*******************************************************
NAVIGATION EVENT HANDLERS
This handles events related to navigation interactions.
********************************************************/

import * as Cookies from '../../lib/_cookie-js/js.cookie';

import addHoverClass from '../universal/hover/add-class';
import addScrollTabArrows from './scroll-tabs/arrows/add';
import adjustScrollTabArrows from './scroll-tabs/arrows/adjust';
import clearSideNavSearch from './side/search/clear';
import closeSideNav from './side/close';
import doOnWindowResize from '../universal/window-resize/do-on-window-resize';
import openSideNav from './side/open';
import removeHoverClass from '../universal/hover/remove-class';
import openDefaultTab from './scroll-tabs/toggle-default-sub-pages';
//import scrollToSelectedTab from './scroll-tabs/scroll-to-selected';
import toggleDropdownMenu from './section/toggle-dropdown';
import toggleSideNavSubSection from './side/sub-section/toggle';
import triggerCloseSubDropdown from './section/trigger-close-dropdown';
import triggerItemLink from './section/trigger-item-link';
import triggerScrollViaNavArrow from './scroll-tabs/arrows/trigger-scroll';
import triggerToggleSubPages from './scroll-tabs/trigger-toggle-sub-pages';
import watchSideNavSearch from './side/search/watch';

export default function addNavigationEventHandlers() {

    // Add left/right arrows to all scroll tab navigation bars on the page
    addScrollTabArrows();

    // Open the default dropdown box for the section
    openDefaultTab();

    // Scroll the selected scroll tab into view (when possible) - killed by Herb <--- Haha!
    //scrollToSelectedTab();

    // Opens the offscreen navigation menu
    $(document).on('click', '.open-side-nav', openSideNav);

    // Closes the offscreen navigation menu
    $(document).on('click', '.side-nav-is-open, .side-nav__close', closeSideNav);

    // Catch taps/clicks on navigation items with a single link
    $(document).on('click', '.s-nav__item, .section-nav__item', triggerItemLink);

    // Toggles a sub navigation dropdown menu
    $(document).on('touchstart mouseenter', '.s-nav__item, .section-nav__item', toggleDropdownMenu);

    // Controls hover effect on section navigation item and dropdown links
    $(document).on('touchstart mouseenter', '.s-nav__item, .s-sub-nav__link, .side-nav__item, .section-nav__item, .section-sub-nav__link, .rwnav-section__item, .rwnav-section-sub__link', addHoverClass);
    $(document).on('mouseleave', '.s-nav__item, .s-sub-nav__link, .side-nav__item, .section-nav__item, .section-sub-nav__link, .rwnav-section__item, .rwnav-section-sub__link', removeHoverClass);

    // Hides a sub navigation dropdown menu
    $(document).on('mouseleave', '.s-nav__item, .s-sub-nav__group, .section-nav__item, .section-sub-nav__group', triggerCloseSubDropdown);

    // Handle typing in page search box in the section side navigation
    $(document).on('keyup', '.side-nav__search', watchSideNavSearch);

    // Clear the page search box in the section side navigation
    $(document).on('click', '.side-nav__clear-search', clearSideNavSearch);

    // Toggle a sub-section in the side nav
    $(document).on('click', '.side-nav__sub-section', toggleSideNavSubSection);

    // Show sub pages when clicking on a scroll tab
    $(document).on('click', '.scroll-tab', triggerToggleSubPages);

    // Scroll the scroll tabs navigation when an arrow is clicked/tapped
    $(document).on('click', '.nav-arrow-left, .nav-arrow-right', triggerScrollViaNavArrow);

    // Figure out of if the scroll tabs arrows should appear when the viewport is resized
    const $scrollTabs = $('.scroll-tabs');
    if ($scrollTabs.length > 0) {
        doOnWindowResize(() => {
            $scrollTabs.each(function adjustArrows() { adjustScrollTabArrows($(this)); });
        });
    }

    $(() => {
        // On page load, set the section content cookie if we're in a section/content home page
        // This feature persists the section content navigation even if you click on a page that technically
        // belongs to another contenct section (ex. if you click a /baseball/ link from the DFS nav, you'll
        // still continue to see the DFS nav once the new page loads)
        //const $activeContent = $('.top-nav-section__item.is-active');
        //const section = $activeContent.data('navSection') || $('#search-for-players').data('sport');
        //if (section === 'HOME' || section === 'All') { return; }

        const sectionLinks = [];
        $('a[data-is-section-link]').each(function loopLinks() {
            const link = $(this).attr('href');
            sectionLinks.push(link);
            sectionLinks.push(`${link}index.php`);
        });

        const pathName = window.location.pathname || '';

        if (sectionLinks.includes(pathName) || pathName.includes('/article.php') || pathName.includes('/article/')) {
            const $activeContent = $('.top-nav-section__item.is-active');
            const section = $activeContent.data('navSection') || $('#search-for-players').data('sport') || '';
            const content = $activeContent.data('navContent') || '';
            if (section && content && !['HOME', 'ALL'].includes(section)) {
                Cookies.set(`rwnav_${section}`, content);
            }
        }
    });

}
